'use client';

import { forwardRef, useEffect, useRef, useState } from 'react';

interface SimpleImagePlaceholderProps {
  width?: number;
  height?: number;
  text?: string;
  backgroundColor?: string;
  textColor?: string;
  className?: string;
}

const SimpleImagePlaceholder = forwardRef<HTMLDivElement, SimpleImagePlaceholderProps>(
  ({ 
    width = 300, 
    height = 300, 
    text, 
    backgroundColor = '#f3f4f6', 
    textColor = '#6b7280',
    className = ''
  }, ref) => {
    const [displayText, setDisplayText] = useState(text || 'Resim Yok');
    const canvasRef = useRef<HTMLCanvasElement>(null);
    
    // Canvas üzerine placeholder görsel çizme
    useEffect(() => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      
      // Canvas boyutunu ayarla
      canvas.width = width;
      canvas.height = height;
      
      // Arkaplan rengi
      ctx.fillStyle = backgroundColor;
      ctx.fillRect(0, 0, width, height);
      
      // Çapraz çizgiler
      ctx.strokeStyle = '#e5e7eb';
      ctx.lineWidth = 1;
      
      // İlk çapraz çizgi
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(width, height);
      ctx.stroke();
      
      // İkinci çapraz çizgi
      ctx.beginPath();
      ctx.moveTo(width, 0);
      ctx.lineTo(0, height);
      ctx.stroke();
      
      // Metin için stil ayarları
      ctx.fillStyle = textColor;
      ctx.font = `${Math.max(16, Math.min(width, height) / 15)}px Arial, sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      
      // Metni ortala
      ctx.fillText(displayText, width / 2, height / 2);
      
      // Daire çiz
      ctx.beginPath();
      ctx.arc(width / 2, height / 2, Math.min(width, height) / 6, 0, Math.PI * 2);
      ctx.strokeStyle = '#d1d5db';
      ctx.lineWidth = 2;
      ctx.stroke();
    }, [width, height, displayText, backgroundColor, textColor]);
    
    return (
      <div 
        ref={ref} 
        className={`relative overflow-hidden flex items-center justify-center ${className}`}
        style={{ width: `${width}px`, height: `${height}px` }}
      >
        <canvas ref={canvasRef} width={width} height={height} />
      </div>
    );
  }
);

SimpleImagePlaceholder.displayName = 'SimpleImagePlaceholder';

export default SimpleImagePlaceholder; 